import { Action } from '@ngrx/store';
import { LocationPreferencesDTO } from '@staff-app/models/locationDTO';

export enum LocationActionTypes {
  SelectLocations = '[Location] Select Locations',
  RemoveSelectedLocation = '[Location] Remove Selected Location',
  GetAvailableAndSelectedLocations = '[Location] Get Available and Selected Locations',
  GetAvailableAndSelectedLocationsSuccessful = '[Location] Get Available and Selected Locations Successful',
  SaveUserPreferredLocations = '[Location] Save User Preferred Locations',
  SaveUserPreferredLocationsSuccessful = '[Location] Save User Preferred Locations Successful',
  NavigateAway = '[Location] Navigate Away'
}

export class GetAvailableAndSelectedLocations implements Action {
  readonly type = LocationActionTypes.GetAvailableAndSelectedLocations;

  constructor(public payload: number) { }
}
export class GetAvailableAndSelectedLocationsSuccessful implements Action {
  readonly type =
    LocationActionTypes.GetAvailableAndSelectedLocationsSuccessful;

  constructor(public payload: LocationPreferencesDTO) { }
}
export class SelectLocations implements Action {
  readonly type = LocationActionTypes.SelectLocations;

  constructor(public payload: any) { }
}

export class RemoveSelectedLocation implements Action {
  readonly type = LocationActionTypes.RemoveSelectedLocation;

  constructor(public payload: number) { }
}
export class SaveUserPreferredLocations implements Action {
  readonly type = LocationActionTypes.SaveUserPreferredLocations;

  constructor(
    public payload: LocationPreferencesDTO,
    public isAddMore: boolean,
    public isEditMode = false
  ) { }
}

export class SaveUserPreferredLocationsSuccessful implements Action {
  readonly type = LocationActionTypes.SaveUserPreferredLocationsSuccessful;

  constructor(public isGoToPrevious: boolean) { }
}
export class NavigateAway implements Action {
  readonly type = LocationActionTypes.NavigateAway;

  constructor() { }
}
export type LocationActions =
  | SelectLocations
  | RemoveSelectedLocation
  | GetAvailableAndSelectedLocations
  | GetAvailableAndSelectedLocationsSuccessful
  | SaveUserPreferredLocations
  | SaveUserPreferredLocationsSuccessful
  | NavigateAway;
